import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import {
    CommonI18nPipe,
    KvI18nService,
} from '@kv-common-components/kv-common-components';

@Pipe({
    name: 'i18n',
    pure: true,
})
export class I18nPipe extends CommonI18nPipe implements PipeTransform {
    constructor(kvI18nService: KvI18nService, logger: NGXLogger) {
        super(kvI18nService, logger);
    }

    public transform(value: string, replaceValue?: string): string {
        return super.transform(value, replaceValue);
    }
}
